<template>
  <div>
    <h4>{{ data.title }}</h4>

    <div class="mb-4" v-if="data.description">
      <h6 class="my-3">Вопрос:</h6>
      <quill-editor
        v-model="data.description"
        :options="editorOption"
        @focus="focus($event)"
      />
    </div>

    <div v-if="data.answers.length">
      <h6 class="my-2">Ответы:</h6>
      <ul>
        <li v-for="(answer, k) in data.answers" :key="k">
          <div :class="`questions-test ${answer.is_true ? 'true' : ''}`">
            <div v-if="answer['img']" class="questions-test-img">
              <img :src="answer['img']" />
            </div>
            <div class="questions-test-title">
              <h6>{{ answer["title"] }}</h6>
              <span
                v-if="answer['group_symbol'] && color[answer['group_symbol']]"
                class="badge badge-info"
                :style="{ backgroundColor: color[answer['group_symbol']] }"
                >Группа: {{ answer["group_symbol"] }}</span
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
  
  <script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [],
        },
        readOnly: true,
        theme: "snow",
      },
      color: {
        A: "#00796B",
        B: "#FF3D00",
        C: "#7B1FA2",
        D: "#303F9F",
        E: "#1B5E20",
        F: "#C62828",
        G: "#5C6BC0",
        H: "#212121",
      },
    };
  },
  props: ["data"],
  components: {
    quillEditor,
  },
  methods: {
    focus(event) {
      event.enable(false);
    },
  },
};
</script>